module.exports = __webpack_public_path__ + "static/media/logo-vg.5bcb058b.png";